module.exports = __webpack_public_path__ + "static/image/service/pc/robot.jpg?eb82caea";